import React from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/bulkPurchase/colorPickerStyles';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { IAvailableColorWithId } from 'utils/api/models/eshop/products';
import { ColorDot, ColorDotWrapper, CrossLine } from './ColorDot';

// @ts-ignore
const useStyles = makeStyles(styles);

const lightColors = ['#faf6f2'];

export enum ColorPickerPosition {
	VERTICAL = 'VERTICAL',
	HORIZONTAL = 'HORIZONTAL',
}

interface ISliderProps {
	colors: IAvailableColorWithId[];
	setSelectedColor: React.Dispatch<React.SetStateAction<string>>;
	selectedColor?: string | null;
	numberOfItemsOnSlide: number;
	position: ColorPickerPosition;
	itemSize: number;
	itemsSeparator: number;
	carouselVisible: boolean;
}

const ColorSlider = ({
	colors,
	setSelectedColor,
	selectedColor,
	numberOfItemsOnSlide,
	position,
	itemSize,
	itemsSeparator,
	carouselVisible,
}: ISliderProps) => {
	const sliderSize: number = 10;

	const classes = useStyles({ position, size: sliderSize, carouselVisible });

	const DotElement = ({ index, isLightColor }: { index: number; isLightColor: boolean }) => {
		if (colors[index].color.includes('#')) {
			return (
				<ColorDot
					isLightColor={isLightColor}
					color={colors[index].color}
					unavailable={!colors[index].available}
				/>
			);
		}
		return <></>;
	};

	return (
		<div className={classes.sliderWrapper}>
			{[...Array(numberOfItemsOnSlide)].map((_, itemNumber) => {
				const index = itemNumber;
				return (
					<ConditionalRender
						key={index}
						show={index < colors.length}
						onTrue={() => (
							<ColorDotWrapper
								selected={selectedColor === colors[index].color}
								separator={itemsSeparator}
								size={itemSize}
								position={position}
								available={!!colors[index].available}
								first={itemNumber === 0}
								last={itemNumber === numberOfItemsOnSlide - 1 || index === colors.length - 1}
								onClick={() => {
									setSelectedColor(colors[index].color);
								}}
							>
								<DotElement
									index={index}
									isLightColor={lightColors ? lightColors.includes(colors[index].color) : false}
								/>
								<ConditionalRender show={!colors[index].available} onTrue={() => <CrossLine />} />
							</ColorDotWrapper>
						)}
					/>
				);
			})}
		</div>
	);
};

export default ColorSlider;
